export default __webpack_public_path__ + "static/media/003-lol.f2c6d1de.svg";